import type { Values } from '@web-platform/shared-universal-types-utils/src/utils';

export const BAGGAGE_TYPE = {
  CHECKED_BAGGAGE: 'checkedBaggage',
  CABIN_BAGGAGE: 'cabinBaggage',
} as const;

export type BaggageType = Values<typeof BAGGAGE_TYPE>;

export const ASSESSMENT_TYPE = {
  UNKNOWN: 'UNKNOWN', // baggage information unknown
  INCLUDED: 'INCLUDED', // free baggage included
  FEE: 'FEE', // baggage included with a fee
  UNAVAILABLE: 'UNAVAILABLE', // baggage not included
} as const;

export type AssessmentType = Values<typeof ASSESSMENT_TYPE>;

export const FARE_ATTRIBUTE_TYPES = {
  PERSONAL_ITEM: 'PERSONAL_ITEM',
  CABIN_BAGGAGE: 'CABIN_BAGGAGE',
  CHECKED_BAGGAGE: 'CHECKED_BAGGAGE',
  SEAT_PRE_RESERVATION: 'SEAT_PRE_RESERVATION',
  ADVANCE_CHANGE: 'ADVANCE_CHANGE',
  CANCELLATION: 'CANCELLATION',
} as const;

export type FareAttributeTypes = Values<typeof FARE_ATTRIBUTE_TYPES>;
